import { RawCollection } from '../types';
import { markItemForRemoval } from './markItemForRemoval';
import { OptimisticUpdater } from './types';
import { unmarkItemForRemoval } from './unmarkItemForRemoval';

export const optimisticallyRemoveFromCollection: OptimisticUpdater<{ itemId: string }> = (queryClient, { itemId }) => {
    let removedFromCollectionId;
    let removedItem;

    queryClient?.setQueriesData(['collections'], (oldData: RawCollection[] | undefined) => {
        if (!oldData) {
            return oldData;
        }

        const { newData, ...removed } = markItemForRemoval(oldData, { itemId });

        ({ removedFromCollectionId, removedItem } = removed);

        return newData;
    });

    const rollback = () => {
        if (!removedItem || !removedFromCollectionId) {
            return;
        }

        queryClient.setQueriesData(['collections'], (oldData: RawCollection[] | undefined) => {
            if (!oldData) {
                return oldData;
            }

            return unmarkItemForRemoval(oldData, {
                collectionId: removedFromCollectionId,
                itemId: removedItem.id,
            }).newData;
        });
    };

    return rollback;
};
